<header class="py-3">
    <div class="container-fluid">
        <div class="row align-items-top justify-content-center">
            <div class="col">
                <figure class="logo-header mx-auto">
                    <img [ngSrc]="logoUrl" priority width="160" height="62.5" class="w-100 h-100 object-fit-container"
                        alt="Vivir Seguro - La Colonial de Seguro">
                </figure>
            </div>
        </div>
    </div>
</header>